import React, { useState } from 'react';
import { connect } from 'react-redux';
import { addSchool } from '../../../redux';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import "./index.css";

function SchoolForm (props) {
    const {
        addSchool,
        schools,
        onClose,
    } = props;

    const [name, setName] = useState("");
    const [status, setStatus] = useState("Inactive");

    const handleChange = (e) => {
        setName(e.target.value);
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        addSchool({ name, status }, schools);
        setName("");
        if(onClose) {
            onClose();
        }
    }

    const handleDropdownChange = (e) => {
        setStatus(e.target.innerText.trim());
    }

    return (
        <div className="addClassForms">
            <div className="input-group">
                <TextField
                    hintText="New School Name"
                    name="name"
                    value={name}
                    onChange={handleChange}
                    fullWidth={true}
                    style={{paddingLeft: "0"}}
                />
                <SelectField
                    hintText={"Status"}
                    name="status"
                    value={status}
                    onChange={(e) => handleDropdownChange(e)}
                    fullWidth={true}
                >
                    <MenuItem
                        key={"Inactive"}
                        value={"Inactive"}
                        primaryText={"Inactive"}
                        id="status"
                    />
                    <MenuItem
                        key={"Active"}
                        value={"Active"}
                        primaryText={"Active"}
                        id="status"
                        />
                </SelectField>
            </div>
            <div className="actions">
                <button onClick={onClose} className="actionButton" style={{display: "block"}}>Close</button>
                <button onClick={handleSubmit} className="pink">Create</button>
            </div>
        </div>
    );
}

export default connect(state => state.root, { addSchool })(SchoolForm);
